import { create } from 'zustand'

const init = {
  sections: [],
  useType: null
}
export const useOrgInfoStore = create((set) => ({
  ...init,
  setSections: (sections) => set({ sections }),
  setUseType: (useType) => set({ useType })
}))
